import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VTextField,_vm._g(_vm._b({staticClass:"outlinedInput",attrs:{"rounded":"","outlined":"","dense":"","append-icon":"mdi-pencil-outline"}},'v-text-field',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }